import { Filter } from "./filter";

type GanttFilter = Filter & {
  scope: "planzone" | "zone" | "project";
  elementTypes?: ("list" | "task" | "milestone" | "event" | "completedWork")[];
};

export type { GanttFilter };
